export type ChronologyCloumnsType = {
  title: string;
  dataIndex: string;
  key: string;
};
export const BankChronologyCloumns: ChronologyCloumnsType[] = [
  {
    title: "Дата начала",
    dataIndex: "start_date",
    key: "start_date",
  },
  {
    title: "Дата окончания",
    dataIndex: "end_date",
    key: "end_date",
  },
  {
    title: "Ставка",
    dataIndex: "base_rate",
    key: "base_rate",
  },
  {
    title: "Агентское вознаграждение",
    dataIndex: "commission_agent_rate",
    key: "commission_agent_rate",
  },
  {
    title: "Превышение ТатБг",
    dataIndex: "excess_tatBg",
    key: "excess_tatBg",
  },
  { title: "Превышение банка", dataIndex: "excess_bank", key: "excess_bank" },
  {
    title: "Превышение агента",
    dataIndex: "excess_agent",
    key: "excess_agent",
  },
  {
    title: "Комиссия ТатБГ",
    dataIndex: "commission_tatBg_rate",
    key: "commission_tatBg_rate",
  },
  {
    title: "Комиссия Агента",
    dataIndex: "commission_agent_rate",
    key: "commission_agent_rate",
  },
];

export const AgentBankChronologyColumns: ChronologyCloumnsType[] = [
  { title: "Дата начала", dataIndex: "start_date", key: "start_date" },
  { title: "Дата окончания", dataIndex: "end_date", key: "end_date" },
  {
    title: "Агентское вознаграждение",
    dataIndex: "commission_agent_rate",
    key: "commission_agent_rate",
  },
  { title: "Завышение", dataIndex: "excess_agent", key: "excess_agent" },
];
